



import Vue from "vue";
import Tick from "./tick.vue";
export default Vue.extend({
  name: "FitIcon",
  components: {
    Tick
  },
  props: {
    icon: {
      // 弹出框标题
      type: String,
      default: "info"
    }
  },
  computed: {
    iconClass() {
      return this.icon === "loading"
        ? "weui-loading"
        : "weui-icon-" + this.icon;
    }
  }
});
